module.exports = __webpack_public_path__ + "static/media/flask-orange.a5a70f75.svg";